import clsx from 'clsx'
import React, { forwardRef, InputHTMLAttributes } from 'react'

import cl from './Textarea.module.scss'

interface TextareaProps extends InputHTMLAttributes<HTMLTextAreaElement> {}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>((props, ref) => {
	const { className, ...HTMLTextareaProps } = props

	return <textarea ref={ref} className={clsx(cl.root, className)} {...HTMLTextareaProps}></textarea>
})
